module.exports = __webpack_public_path__ + "img/11.5ae0fc52.png";